import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { LicenceSearchItem } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputText, ValidatedText } from '@/components';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class LicenceSearchItemGuiDef extends GuiDef<LicenceSearchItem> {
    constructor() {
        super('LicenceSearchItem');

        const LicenceName = new FieldDef<LicenceSearchItem>();
        LicenceName.Name = 'LicenceName';
        LicenceName.FieldName = 'LicenceName';
        LicenceName.DefinedFor = 'Both';
        LicenceName.TranslationKey = 'licencesearchitem.licencename';
        LicenceName.Editable = true;
        LicenceName.Filterable = true;
        LicenceName.Sortable = true;
        LicenceName.CssClasses = '';
        LicenceName.value = (licencesearchitem) => licencesearchitem.LicenceName;
        LicenceName.setValue = (licencesearchitem, value) => (licencesearchitem.LicenceName = value);
        LicenceName.DetailEditor = markRaw(InputText);
        LicenceName.DetailEditorProps = {};
        LicenceName.CellEditor = markRaw(InputText);
        LicenceName.CellEditorProps = {};
        LicenceName.CellRenderer = markRaw(ValidatedText);
        LicenceName.CellRendererProps = {};
        LicenceName.Validator = null;
        LicenceName.SortDirection = undefined;
        LicenceName.cellClassRules = undefined;
        LicenceName.MinWidth = undefined;
        LicenceName.MaxWidth = undefined;
        LicenceName.Tooltip = null;
        this.Fields.push(LicenceName);

        const LicencePeriod = new FieldDef<LicenceSearchItem>();
        LicencePeriod.Name = 'LicencePeriod';
        LicencePeriod.FieldName = 'LicencePeriod';
        LicencePeriod.DefinedFor = 'Both';
        LicencePeriod.TranslationKey = 'licencesearchitem.licenceperiod';
        LicencePeriod.Editable = true;
        LicencePeriod.Filterable = true;
        LicencePeriod.Sortable = true;
        LicencePeriod.CssClasses = '';
        LicencePeriod.value = (licencesearchitem) => licencesearchitem.LicencePeriod;
        LicencePeriod.setValue = (licencesearchitem, value) => (licencesearchitem.LicencePeriod = value);
        LicencePeriod.DetailEditor = markRaw(InputText);
        LicencePeriod.DetailEditorProps = {};
        LicencePeriod.CellEditor = markRaw(InputText);
        LicencePeriod.CellEditorProps = {};
        LicencePeriod.CellRenderer = markRaw(ValidatedText);
        LicencePeriod.CellRendererProps = {};
        LicencePeriod.Validator = null;
        LicencePeriod.SortDirection = undefined;
        LicencePeriod.cellClassRules = undefined;
        LicencePeriod.MinWidth = undefined;
        LicencePeriod.MaxWidth = undefined;
        LicencePeriod.Tooltip = null;
        this.Fields.push(LicencePeriod);

        const LicenceStatus = new FieldDef<LicenceSearchItem>();
        LicenceStatus.Name = 'LicenceStatus';
        LicenceStatus.FieldName = 'LicenceStatus';
        LicenceStatus.DefinedFor = 'Both';
        LicenceStatus.TranslationKey = 'licencesearchitem.licencestatus';
        LicenceStatus.Editable = true;
        LicenceStatus.Filterable = true;
        LicenceStatus.Sortable = true;
        LicenceStatus.CssClasses = '';
        LicenceStatus.value = (licencesearchitem) => licencesearchitem.LicenceStatus;
        LicenceStatus.setValue = (licencesearchitem, value) => (licencesearchitem.LicenceStatus = value);
        LicenceStatus.DetailEditor = markRaw(InputText);
        LicenceStatus.DetailEditorProps = {};
        LicenceStatus.CellEditor = markRaw(InputText);
        LicenceStatus.CellEditorProps = {};
        LicenceStatus.CellRenderer = markRaw(ValidatedText);
        LicenceStatus.CellRendererProps = {};
        LicenceStatus.Validator = null;
        LicenceStatus.SortDirection = undefined;
        LicenceStatus.cellClassRules = undefined;
        LicenceStatus.MinWidth = undefined;
        LicenceStatus.MaxWidth = undefined;
        LicenceStatus.Tooltip = null;
        this.Fields.push(LicenceStatus);

        const LicenceValue = new FieldDef<LicenceSearchItem>();
        LicenceValue.Name = 'LicenceValue';
        LicenceValue.FieldName = 'LicenceValue';
        LicenceValue.DefinedFor = 'Both';
        LicenceValue.TranslationKey = 'licencesearchitem.licencevalue';
        LicenceValue.Editable = true;
        LicenceValue.Filterable = true;
        LicenceValue.Sortable = true;
        LicenceValue.CssClasses = '';
        LicenceValue.value = (licencesearchitem) => licencesearchitem.LicenceValue;
        LicenceValue.setValue = (licencesearchitem, value) => (licencesearchitem.LicenceValue = value);
        LicenceValue.DetailEditor = markRaw(InputText);
        LicenceValue.DetailEditorProps = {};
        LicenceValue.CellEditor = markRaw(InputText);
        LicenceValue.CellEditorProps = {};
        LicenceValue.CellRenderer = markRaw(ValidatedText);
        LicenceValue.CellRendererProps = {};
        LicenceValue.Validator = null;
        LicenceValue.SortDirection = undefined;
        LicenceValue.cellClassRules = undefined;
        LicenceValue.MinWidth = undefined;
        LicenceValue.MaxWidth = undefined;
        LicenceValue.Tooltip = null;
        this.Fields.push(LicenceValue);

        const ParticipantName = new FieldDef<LicenceSearchItem>();
        ParticipantName.Name = 'ParticipantName';
        ParticipantName.FieldName = 'ParticipantName';
        ParticipantName.DefinedFor = 'Both';
        ParticipantName.TranslationKey = 'licencesearchitem.participantname';
        ParticipantName.Editable = true;
        ParticipantName.Filterable = true;
        ParticipantName.Sortable = true;
        ParticipantName.CssClasses = '';
        ParticipantName.value = (licencesearchitem) => licencesearchitem.ParticipantName;
        ParticipantName.setValue = (licencesearchitem, value) => (licencesearchitem.ParticipantName = value);
        ParticipantName.DetailEditor = markRaw(InputText);
        ParticipantName.DetailEditorProps = {};
        ParticipantName.CellEditor = markRaw(InputText);
        ParticipantName.CellEditorProps = {};
        ParticipantName.CellRenderer = markRaw(ValidatedText);
        ParticipantName.CellRendererProps = {};
        ParticipantName.Validator = null;
        ParticipantName.SortDirection = undefined;
        ParticipantName.cellClassRules = undefined;
        ParticipantName.MinWidth = undefined;
        ParticipantName.MaxWidth = undefined;
        ParticipantName.Tooltip = null;
        this.Fields.push(ParticipantName);
    }

    public async LoadDependencies() {}
}
